<template>
	<footer v-if="!showFooter" class="private-footer-new">

		<div class="footer-bottom">
			<div class="container">
				<div class="row">
					<div class="col-lg-4">
          <p class="private-footer-new-p">© Copyright Tap huan - Nhà xuất bản Giáo dục</p>
        </div>
        <div class="col-lg-8">
          <ul class="ul-footer margin-0 p-0">
            <li>Giới thiệu</li>
            <li>Trung tâm trợ giúp</li>
            <li>Điều khoản</li>
            <li>Chính sách bảo mật</li>
            <li>
              <i class="fab fa-facebook-square footer-icon-facebk"></i>&nbsp;
              <i class="fas fa-envelope"></i>
              <!-- <img src="@/assets/img/icon_email.png" alt="" style="height:16px;"> -->
            </li>
          </ul>
        </div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
		data() {
			return {
				showFooter: true
			};
		},
		watch: {
			'$route': 'checkDisplayFooter'
		},
		creatd() {
			this.checkDisplayFooter();
		},
		methods: {
			checkDisplayFooter() {
				this.showFooter = this.$router.history.current.meta.hideFooter || this.$router.history.current.meta.public ? true : false;
			}
		}
	};
</script>

<style lang="scss" scoped>
</style>